import { render } from "./branch-create.vue?vue&type=template&id=163fb88f"
import script from "./branch-create.vue?vue&type=script&lang=js"
export * from "./branch-create.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__